import { getIsAIPlannerBlocking } from '@bridebook/web/lib/ai-planner/selectors';
import {
  getShowEnquiryForm,
  getShowMultipleEnquiryForm,
} from '@bridebook/web/lib/enquiries/selectors';
import type { IApplicationState } from '@bridebook/web/lib/types';

// Used to check if any blocking popup is visible when opening some other popup/modals/drawers
export const getIsAnyBlockingPopupVisible = (state: IApplicationState) =>
  state.bbcommon.openedModalIds.length > 0 ||
  getIsAIPlannerBlocking(state) ||
  state.ui.pushNotificationOptInShown ||
  state.ui.lostLeadModal.show ||
  state.ui.isRatingModalVisible ||
  state.ui.isCalendlyModalVisible ||
  getShowEnquiryForm(state) ||
  getShowMultipleEnquiryForm(state);
